import crossedEyeIcon from "~/components/ui/icons/svg/crossed-eye-icon.svg";
import eyeIcon from "~/components/ui/icons/svg/eye-icon.svg";

export const EyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#60646C"
      className="h-4 w-4"
    >
      <use xlinkHref={`#${eyeIcon}`} />
    </svg>
  );
};

export const CrossedEyeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#60646C"
      className="h-4 w-4"
    >
      <use xlinkHref={`#${crossedEyeIcon}`} />
    </svg>
  );
};
